import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { useViewer, useViewerRoles } from '@treams/treams-hooks';
import { AnalyticsEngagementOpenQuestionAnswer } from '@treams/treams-network';
import { Badge, Button, Paragraph } from '@treams/treams-ui';

type EngagementQuestionButtonProps = {
	answerID: AnalyticsEngagementOpenQuestionAnswer['id'];
	repliesCount?: number;
};

const EngagementQuestionButton = ({ answerID, repliesCount }: EngagementQuestionButtonProps) => {
	const { t } = useTranslation();

	const viewer = useViewer();
	const userRoles = useViewerRoles();
	const isSuper = userRoles.isWorkspaceSuperuser || userRoles.isEngagementOfficer;

	return viewer ? (
		<Button
			link={`/engagement-replies/${answerID}:${isSuper ? 'super' : viewer.id}`}
			title={t('engagement.question.reply.buttonTitle')}
			ml={2}
			flexShrink={0}
			type="secondary"
			small
			rightIcon={
				<Box ml={1}>
					{repliesCount === undefined ? (
						<Badge.Skeleton size={20} />
					) : (
						<Badge size={20} color="lightBlue" icon={<Paragraph>{repliesCount}</Paragraph>} />
					)}
				</Box>
			}
		/>
	) : null;
};

export default EngagementQuestionButton;
